var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWarningRhombus(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7610_143603)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -0.799805,
    y: 12,
    width: 18.1019,
    height: 18.1019,
    rx: 3,
    transform: "rotate(-45 -0.799805 12)",
    fill: "#FFC941"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4128 15.0141C11.5792 14.909 11.7749 14.8529 11.9751 14.8529C12.2436 14.8529 12.5011 14.9537 12.6909 15.1331C12.8807 15.3125 12.9874 15.5559 12.9874 15.8096C12.9874 15.9988 12.928 16.1838 12.8168 16.3411C12.7056 16.4985 12.5475 16.6211 12.3625 16.6935C12.1775 16.7659 11.974 16.7849 11.7777 16.7479C11.5813 16.711 11.4009 16.6199 11.2594 16.4861C11.1178 16.3523 11.0214 16.1818 10.9823 15.9963C10.9433 15.8107 10.9633 15.6183 11.0399 15.4435C11.1166 15.2687 11.2463 15.1193 11.4128 15.0141Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2594 7.47943C11.4492 7.30001 11.7067 7.19922 11.9751 7.19922C12.2436 7.19922 12.5011 7.30001 12.6909 7.47943C12.8807 7.65885 12.9874 7.90219 12.9874 8.15593V11.9828C12.9874 12.2365 12.8807 12.4798 12.6909 12.6593C12.5011 12.8387 12.2436 12.9395 11.9751 12.9395C11.7067 12.9395 11.4492 12.8387 11.2594 12.6593C11.0695 12.4798 10.9629 12.2365 10.9629 11.9828V8.15593C10.9629 7.90219 11.0695 7.65885 11.2594 7.47943Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7610_143603"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningRhombus);
export default __webpack_public_path__ + "static/media/warning-rhombus.12a83f4c56dc2a29faaf4eb66d578efc.svg";
export { ForwardRef as ReactComponent };